var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 513,
    viewBox: "0 0 513 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_418)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.5 0.5C249.167 0.5 263.833 0.5 278.5 0.5C378.769 13.0418 450.269 65.0418 493 156.5C503.296 181.684 509.796 207.684 512.5 234.5C512.5 249.167 512.5 263.833 512.5 278.5C499.958 378.769 447.958 450.269 356.5 493C331.316 503.296 305.316 509.796 278.5 512.5C263.833 512.5 249.167 512.5 234.5 512.5C134.231 499.958 62.7312 447.958 20 356.5C9.70393 331.316 3.20393 305.316 0.5 278.5C0.5 263.833 0.5 249.167 0.5 234.5C13.0418 134.231 65.0418 62.7312 156.5 20C181.684 9.70393 207.684 3.20393 234.5 0.5Z",
    fill: "#F42C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 68C96.206 68 68 96.206 68 131V383C68 417.794 96.206 446 131 446H383C417.794 446 446 417.794 446 383V131C446 96.206 417.794 68 383 68H131ZM149.773 149H221.211L271.941 221.088L333.5 149H356L282.102 235.52L373.227 365H301.807L242.938 281.363L171.5 365H149L232.777 266.932L149.773 149ZM184.227 167L311.193 347H338.773L211.807 167H184.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 149L221 148.5L374 365L301.5 365L150 149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.786 148.325L356.558 148.48L171.262 364.998L148.489 364.847L333.786 148.325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 513,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ba22ea7f4c3ad45722706b283acbcf5b.svg";
export { ForwardRef as ReactComponent };